import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LangMenu from "./LangMenu";
import { Fab } from "@mui/material";
import { ChangeCircleOutlined } from "@mui/icons-material";
import SwitchDialog from "./SwitchDialog";
import { useCookies } from "react-cookie";



const useStyles = makeStyles(theme => ({

    title: {
        flexGrow: 1,
        color: '#5D3FD2'
    },
    toolBar: {
        backgroundColor: '#F8F8F8',
        color: '#333',
        paddingLeft: 80,
        borderTop: '12px solid #0D2030'
    },
    avatar: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
    },
    username: {
        marginLeft: 5
    }
}));


const ToolBar = ({ title = "", showAvatar = true, right, ...props }) => {


    const full = useSelector(state => state.auth);
    // const [cookies] = useCookies(['access_token', 'refresh_token', 'isMaster', 'tenantName']);



    const classes = useStyles();
    const [isDialogOpen, setDialogOpen] = useState(false);

    const closeDetayDialog = () => {
        setDialogOpen(false);
    }

    useEffect(() => {
        const toolbar = document.getElementById('fixedToolBar');
        const content = document.getElementById('content');
        if (content.classList.contains("expanded")) {
            toolbar.classList.add("expanded");
        } else {
            toolbar.classList.remove("expanded");
        }
    }, []);

    return (
        <AppBar position="fixed" elevation={0}>
            <Toolbar id="fixedToolBar" variant="regular" className={classes.toolBar}>
                <Typography variant="h6" className={classes.title}>
                    {title}
                </Typography>

                {right}

                {full.user.tenantName &&
                    <Fab
                        variant="extended"
                        color="primary"
                        aria-label="add"
                        size="small"
                        onClick={() => setDialogOpen(true)}>
                        <ChangeCircleOutlined sx={{ mr: 1 }} />
                        {`${full.user?.tenantName}`}
                    </Fab>
                }



                <LangMenu />

                {showAvatar &&
                    <div className={classes.avatar}>
                        <AccountCircleIcon />
                        <span className={classes.username}>
                            {`${full.user?.adSoyad}`}
                        </span>
                    </div>
                }

            </Toolbar>

            <SwitchDialog
                open={isDialogOpen}
                onClose={closeDetayDialog}
            />
        </AppBar>
    );

};


export default ToolBar;
